import {Model, ICurrency, INumber, IDate} from 'MWC';

export default class RateModel extends Model {
    static fields = {
        ccyB: {
            fieldConstructor: ICurrency
        },
        ccyA: {
            fieldConstructor: ICurrency
        },
        rateB: {
            value: 0,
            fieldConstructor: INumber
        },
        rateA: {
            value: 0,
            fieldConstructor: INumber
        },
        rateC: {
            value: 0,
            fieldConstructor: INumber
        },
        prevRateB: {
            value: 0,
            fieldConstructor: INumber
        },
        prevRateA: {
            value: 0,
            fieldConstructor: INumber
        },
        date: {
            fieldConstructor: IDate
        }
    };
}
